import PageWrapper from 'components/utils/PageWrapper';
import StudyRun from 'pages/StudyRun';

export const runAStudyRoutes = {
    path: '/run-a-study',
    element: (
        <PageWrapper titleId="common_run_a_study">
            <StudyRun />
        </PageWrapper>
    ),
};
